
















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class InsertChartOutlinedIcon extends Vue {
	@Prop({ default: false}) public decorative: boolean;
	@Prop({ default: 'currentColor'}) public fillColor: string;
	@Prop({ default: 24}) public size: number;
}
